import { Injectable, inject } from '@angular/core';
import { ExternalAuthService, IAuthStrategy, InternalAuthService } from '@xbh/common-lib';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DynamicAuthStrategyService implements IAuthStrategy {
  private readonly internalAuth = inject(InternalAuthService);
  private readonly externalAuth = inject(ExternalAuthService);

  /**
   * @description 現在のホスト名に基づいて、社内環境か社外環境かを判定します。
   * @returns true: 社内環境、false: 社外環境
   */
  get isCurrentlyInternal(): boolean {
    const currentHostname = window.location.hostname;
    const currentUrl = window.location.href;

    const isSessionInternal = sessionStorage.getItem('from_mplog') === 'true';
    if (isSessionInternal) {
      return true;
    }

    if (currentUrl.includes('businessScreenId=')) {
      return true;
    }
    if (currentHostname === environment.internalHost) {
      return true;
    }
    if (currentHostname === environment.externalHost) {
      return false;
    }
    return environment.isInternal;
  }

  async acquireToken(): Promise<void> {
    if (this.isCurrentlyInternal) {
      return this.internalAuth.acquireToken();
    } else {
      return this.externalAuth.acquireToken();
    }
  }

  async handleTokenRefreshOrRedirect(): Promise<void> {
    if (this.isCurrentlyInternal) {
      return this.internalAuth.handleTokenRefreshOrRedirect();
    } else {
      return this.externalAuth.handleTokenRefreshOrRedirect();
    }
  }
}
